import { useTranslation } from 'react-i18next';
import {
  StyledContainer,
  StyledInstructions,
  StyledAgreementText,
} from './styled';

const InstructionsContainer = () => {
  const { t } = useTranslation();

  return (
    <StyledContainer>
      <StyledInstructions>
        {t('distribution:uploadAudioModal:instructions')}
      </StyledInstructions>
      <StyledAgreementText>
        {t('distribution:uploadAudioModal:agreement')}
      </StyledAgreementText>
    </StyledContainer>
  );
};

export default InstructionsContainer;
